import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

export const IconWrapper = styled.div`
  display: flex;
  height: 64px;
  width: 80px;
  padding: 0 20px;
  align-items: center;
  justify-content: flex-end;

  img {
    max-height: 80%;
  }
`
export const Label = styled.div`
  display: flex;
  flex: 1 1;
  align-items: center;
  min-width: 180px;
  height: 64px;
`
export const ButtonElem = styled(FocusNode)<{
  $expand?: boolean
  $width?: number
  $smallButton?: boolean
  $secondary?: boolean
  $withIcon?: boolean
  $iconPositionEnd?: boolean
}>`
  display: flex;
  align-items: stretch;
  margin: ${({ $withIcon }) => ($withIcon ? '0px' : '8px')};
  width: ${({ $expand, $width }) =>
    $expand ? `100%` : $width ? `${$width}px` : 'auto'};
  height: 64px;
  background: ${({ $secondary, theme }) =>
    $secondary
      ? theme.colors.button.backgroundSecondary
      : theme.colors.button.background};
  box-shadow: ${({ theme }) => `inset 0 0 0 2px ${theme.colors.button.border}`};
  font-size: 22px;
  line-height: 1em;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.button.text};
  text-transform: uppercase;
  border-radius: 8px;
  overflow: hidden;
  flex-direction: ${({ $iconPositionEnd }) =>
    $iconPositionEnd ? 'row-reverse' : 'row'};

  ${Label} {
    padding: ${({ $withIcon, $iconPositionEnd }) =>
      $withIcon ? ($iconPositionEnd ? '0 0 0 32px' : '0 32px 0 0') : '0 32px'};
    justify-content: ${({ $withIcon }) =>
      $withIcon ? 'flex-start' : 'center'};
  }

  ${({ $smallButton, $withIcon }) =>
    $smallButton &&
    css`
      font-size: 18px;
      height: 52px;
      ${IconWrapper} {
        width: 90px;
        height: 52px;
      }
      ${Label} {
        padding: ${$withIcon ? '0 16px 0 10px' : '0 10px'};
        height: 52px;
      }
    `};

  &.isFocusedLeaf {
    box-shadow: inset 0 0 0 2px
      ${({ theme }) => theme.colors.button.focusedElem.border};
    & > ${IconWrapper} {
      img {
        filter: invert(75%) sepia(75%) saturate(520%) hue-rotate(150deg)
          brightness(90%) contrast(100%);
      }
    }
    background: ${({ theme }) => theme.colors.button.accent};
    color: ${({ theme }) => theme.colors.primary};
  }
`
